import { fromJS } from 'immutable';
import * as actions from '../../actions/maintenance/taxTransparency';
import { START, SUCCESS, ERROR } from '../../actions/maintenance/global';
import { fetchingState } from '../../constants';
import * as _ from 'lodash';

const initialState = {
  loginSettings: {},
  chartSettings: {},
  statusSettings: {},
  chartType: {},
  emailsBySearch: {},
  searchFormData: {},
  pagination: {
    count: 0,
    page: 1,
    rowsPerPage: 50,
    rowsPerPageOptions: [50, 100, 1000, 5000, 10000],
  },
  notificationRuns: {},
  runsPagination: {
    count: 0,
    page: 1,
    rowsPerPage: 50,
    rowsPerPageOptions: [50, 100, 1000, 5000, 10000],
  },
  notificationRecords: {},
  recordsPagination: {
    count: 0,
    page: 1,
    rowsPerPage: 50,
    rowsPerPageOptions: [50, 100, 1000, 5000, 10000],
  },
  notificationEmails: {},
  emailsPagination: {
    count: 0,
    page: 1,
    rowsPerPage: 50,
    rowsPerPageOptions: [50, 100, 1000, 5000, 10000],
  },
};

export default (state = fromJS(initialState), action) => {
  switch (action.type) {
    case actions.FETCH_LOGIN_SETTINGS[START]:
      return state.setIn(['loginSettings', 'state'], fetchingState.FETCHING);
    case actions.FETCH_LOGIN_SETTINGS[SUCCESS]:
      let newState = state.setIn(
        ['loginSettings', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['loginSettings', 'data'],
        fromJS(action.data.results || {}),
      );
    case actions.FETCH_LOGIN_SETTINGS[ERROR]:
      return state.setIn(['loginSettings', 'state'], fetchingState.ERROR);

    case actions.UPDATE_LOGIN_SETTINGS[SUCCESS]:
      return state.setIn(
        ['loginSettings', 'data'],
        fromJS(action.data.results ? action.data.results[0] : {}),
      );

    case actions.FETCH_CHART_TYPE[START]:
      return state.setIn(['chartType', 'state'], fetchingState.FETCHING);
    case actions.FETCH_CHART_TYPE[SUCCESS]:
      newState = state.setIn(['chartType', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['chartType', 'data'],
        fromJS(action.data.results || {}),
      );
    case actions.FETCH_CHART_TYPE[ERROR]:
      return state.setIn(['chartSettings', 'state'], fetchingState.ERROR);

    case actions.FETCH_CHART_SETTINGS[START]:
      return state.setIn(['chartSettings', 'state'], fetchingState.FETCHING);
    case actions.FETCH_CHART_SETTINGS[SUCCESS]:
      newState = state.setIn(['chartSettings', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['chartSettings', 'data'],
        fromJS(action.data.results[0] || {}),
      );
    case actions.FETCH_CHART_SETTINGS[ERROR]:
      return state.setIn(['chartSettings', 'state'], fetchingState.ERROR);

    case actions.UPDATE_CHART_SETTINGS[SUCCESS]:
      return state.setIn(
        ['chartSettings', 'data'],
        fromJS(action.data.results ? action.data.results[0] : {}),
      );

    case actions.FETCH_STATUS_SETTINGS[START]:
      return state.setIn(['statusSettings', 'state'], fetchingState.FETCHING);
    case actions.FETCH_STATUS_SETTINGS[SUCCESS]:
      newState = state.setIn(['statusSettings', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['statusSettings', 'data'],
        fromJS(action.data.results || {}),
      );
    case actions.FETCH_STATUS_SETTINGS[ERROR]:
      return state.setIn(['statusSettings', 'state'], fetchingState.ERROR);

    case actions.UPDATE_STATUS_SETTINGS[SUCCESS]:
      return state.setIn(
        ['statusSettings', 'data'],
        fromJS(
          action.data.results
            ? {
                ...action.data.results[0],
                status: action.data.results[0].statuses,
              }
            : {},
        ),
      );
    case actions.SEARCH_TAXPAYER_NOTIFICATIONS_EMAILS[START]:
      return state
        .setIn(['emailsBySearch', 'state'], fetchingState.FETCHING)
        .setIn(['pagination', 'page'], action.page)
        .setIn(['pagination', 'rowsPerPage'], action.pageSize);

    case actions.SEARCH_TAXPAYER_NOTIFICATIONS_EMAILS[SUCCESS]:
      return state
        .setIn(['emailsBySearch', 'state'], fetchingState.LOADED)
        .setIn(
          ['emailsBySearch', 'total'],
          fromJS(_.get(action, 'data.recordCount', 0)),
        )
        .setIn(
          ['emailsBySearch', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        )
        .setIn(
          ['pagination', 'count'],
          fromJS(_.get(action, 'data.recordCount', 0)),
        );

    case actions.SEARCH_TAXPAYER_NOTIFICATIONS_EMAILS[ERROR]:
      return state.setIn(['emailsBySearch', 'state'], fetchingState.ERROR);
    case actions.SET_SEARCH_FORM_DATA: {
      return state.setIn(['searchFormData'], fromJS(action.payload));
    }
    case actions.CHANGE_PAGE: {
      return state.setIn(['pagination', 'page'], action.payload);
    }
    case actions.CHANGE_ROWS_PER_PAGE: {
      return state.setIn(['pagination', 'rowsPerPage'], action.payload);
    }
    case actions.FETCH_NOTIFICATION_RUNS[START]:
      return state
        .setIn(['notificationRuns', 'state'], fetchingState.FETCHING)
        .setIn(['runsPagination', 'page'], action.page)
        .setIn(['runsPagination', 'rowsPerPage'], action.pageSize);

    case actions.FETCH_NOTIFICATION_RUNS[SUCCESS]:
      return state
        .setIn(['notificationRuns', 'state'], fetchingState.LOADED)
        .setIn(
          ['notificationRuns', 'total'],
          fromJS(_.get(action, 'data.propertyCount', 0)),
        )
        .setIn(
          ['notificationRuns', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        )
        .setIn(
          ['runsPagination', 'count'],
          fromJS(_.get(action, 'data.propertyCount', 0)),
        );

    case actions.FETCH_NOTIFICATION_RUNS[ERROR]:
      return state.setIn(['notificationRuns', 'state'], fetchingState.ERROR);

    case actions.CHANGE_RUNS_PAGE: {
      return state.setIn(['runsPagination', 'page'], action.payload);
    }
    case actions.CHANGE_RUNS_ROWS_PER_PAGE: {
      return state.setIn(['runsPagination', 'rowsPerPage'], action.payload);
    }

    case actions.FETCH_NOTIFICATION_RUN_RECORDS[START]:
      return state
        .setIn(['notificationRecords', 'state'], fetchingState.FETCHING)
        .setIn(['recordsPagination', 'page'], action.page)
        .setIn(['recordsPagination', 'rowsPerPage'], action.pageSize);

    case actions.FETCH_NOTIFICATION_RUN_RECORDS[SUCCESS]:
      return state
        .setIn(['notificationRecords', 'state'], fetchingState.LOADED)
        .setIn(
          ['notificationRecords', 'total'],
          fromJS(_.get(action, 'data.recordCount', 0)),
        )
        .setIn(
          ['notificationRecords', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        )
        .setIn(
          ['recordsPagination', 'count'],
          fromJS(_.get(action, 'data.recordCount', 0)),
        );

    case actions.FETCH_NOTIFICATION_RUN_RECORDS[ERROR]:
      return state.setIn(['notificationRecords', 'state'], fetchingState.ERROR);

    case actions.CHANGE_RECORDS_PAGE: {
      return state.setIn(['recordsPagination', 'page'], action.payload);
    }
    case actions.CHANGE_RECORDS_ROWS_PER_PAGE: {
      return state.setIn(['recordsPagination', 'rowsPerPage'], action.payload);
    }

    case actions.FETCH_NOTIFICATION_RUN_EMAILS[START]:
      return state
        .setIn(['notificationEmails', 'state'], fetchingState.FETCHING)
        .setIn(['emailsPagination', 'page'], action.page)
        .setIn(['emailsPagination', 'rowsPerPage'], action.pageSize);

    case actions.FETCH_NOTIFICATION_RUN_EMAILS[SUCCESS]:
      return state
        .setIn(['notificationEmails', 'state'], fetchingState.LOADED)
        .setIn(
          ['notificationEmails', 'total'],
          fromJS(_.get(action, 'data.recordCount', 0)),
        )
        .setIn(
          ['notificationEmails', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        )
        .setIn(
          ['emailsPagination', 'count'],
          fromJS(_.get(action, 'data.recordCount', 0)),
        );

    case actions.FETCH_NOTIFICATION_RUN_EMAILS[ERROR]:
      return state.setIn(['notificationEmails', 'state'], fetchingState.ERROR);

    case actions.CHANGE_EMAILS_PAGE: {
      return state.setIn(['emailsPagination', 'page'], action.payload);
    }
    case actions.CHANGE_EMAILS_ROWS_PER_PAGE: {
      return state.setIn(['emailsPagination', 'rowsPerPage'], action.payload);
    }

    default:
      return state;
  }
};
